import { useState, useEffect, useRef } from 'react';

/**
 * Measures browser RAF rate when enabled.
 * Returns frames-per-second, updated every 500 ms.
 * Returns 0 when disabled.
 */
export function useFpsCounter(enabled: boolean): number {
  const [value, setValue] = useState(0);
  const frameCount = useRef(0);
  const lastTime = useRef(0);

  useEffect(() => {
    if (!enabled) {
      setValue(0);
      return;
    }

    let rafId: number;
    let stopped = false;
    lastTime.current = performance.now();
    frameCount.current = 0;

    function tick(now: number): void {
      if (stopped) return;
      frameCount.current++;
      const dt = now - lastTime.current;
      if (dt >= 500) {
        setValue(Math.round((frameCount.current / dt) * 1000));
        frameCount.current = 0;
        lastTime.current = now;
      }
      rafId = requestAnimationFrame(tick);
    }

    rafId = requestAnimationFrame(tick);
    return () => {
      stopped = true;
      cancelAnimationFrame(rafId);
    };
  }, [enabled]);

  return value;
}
